<template>
  <div class="home hardlist-home">
    <HardwareLayout
      layoutType="HARDLIST"
      layoutTitile="节点提交"
    >
      <Tips
        title="标准节点提交注意事项"
        :tips="$t('tips')"
        class="withdrawal-tips"
      />
      <Node></Node>
      
    </HardwareLayout>

  </div>
</template>

<i18n>
{
  "en": {
    "tips": [
      "1.标准节点分为静态IP专线（单设备 5Gbps - 10Gbps）及动态IP汇聚（单设备 3Gbps- 5Gbps）。",
      " （1）静态IP专线要求及设备配置请参考：<router-link>https://shimo.im/docs/pDQVDH8pr6Pk8qdv<===>https://shimo.im/docs/pDQVDH8pr6Pk8qdv<router-link>",
      " （2）动态IP汇聚要求及设备配置请参考：<router-link>https://shimo.im/docs/QqJtpkCkYvRTQWvx<===>https://shimo.im/docs/QqJtpkCkYvRTQWvx<router-link>",
      "2.标准节点收益根据有效带宽 95 峰月结，具体收益情况请加入官方社群咨询二猫。",
      " （1）有效带宽 95 峰：按自然月结算，在一个自然月内，按账户取每5分钟有效带宽值（出带宽-入带宽）进行降序排列，将带宽数值最高的 5% 的点去掉，剩余最高带宽即为月95带宽峰值计费值。以一月30天为例，默认均为有效取值点，每5分钟1个带宽取值点，每天288个取值点，每月总取值点数为 288x 30 = 8640个；将所有的点按带宽数值降序排列，去掉前5%的点（8640 x 5% = 432 个点），即第433个点为月95峰值带宽计费点。",
      "3.动态IP汇聚需要先填写拨号配置，请前往 软路由 - 汇聚拨号配置 填写，保存服务器信息后选择对应的拨号配置提交即可。",
      "4.请点击下方添加节点提交设备信息，如有疑问，请加入官方群咨询二猫。"
    ]
  }
}
</i18n>


<script>
// @ is an alias to /src
import { mapState, mapActions, mapMutations } from "vuex";
import HardwareLayout from "@/components/Hardware/HardwareLayout.vue";
import moment from "moment";
import { Message } from "element-ui";
import { LANG, SITEKEY } from "../../config/contant.js";
import Tips from "@/components/Common/Tips.vue";
import Node from "@/components/Hardware/Node.vue";

export default {
  name: "home",
  components: {
    HardwareLayout,
    Tips,
    Node
  },
  data() {
    return {};
  },
  computed: mapState({}),
  methods: {
    ...mapActions([])
  },
  created() {}
};
</script>

<style lang="stylus"></style>
